module.exports = __webpack_public_path__ + "img/case2.37d85937.png";